import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SearchForm from '@/components/SearchForm';
import NoData from '@/components/NoData/NoData';
import { valsubstr32addbr, saveFile } from '@/utils/index';
import Cookies from 'js-cookie';
export default {
  components: {
    SearchForm: SearchForm,
    NoData: NoData
  },
  data: function data() {
    return {
      showLoading: false,
      searchFormData: [{
        title: '系统名称',
        key: '',
        placeholder: '请选择所属系统',
        type: 'select',
        selectData: [],
        selectedArr: '',
        value: ''
      }, {
        title: '文档名称',
        key: 'role',
        placeholder: '请输入文档名称关键词',
        type: 'input',
        value: null,
        selectData: [],
        selectedArr: []
      }],
      btnType: 'search,reset',
      tableData: [],
      total: 0,
      tableheight: 512,
      userId: '',
      searchObj: {
        fileName: '',
        systemId: '',
        pageSize: 10,
        pageNum: 1
      }
    };
  },
  created: function created() {
    this.userId = Cookies.get('user_id');
    // this.searchForm(this.searchFormData)

    this.getSystemList();
    this.getHelpDoc();
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.tableheight = window.innerHeight - 332;

      // 监听窗口大小变化
      var self = this;
      window.onresize = function () {
        self.tableheight = window.innerHeight - 332;
      };
    });
  },
  methods: {
    getSystemList: function getSystemList() {
      var _this = this;
      this.$API.getRequest({
        url: '/platform/systemInner/list'
      }).then(function (res) {
        if (res.code === '0000000000') {
          res.result.records.forEach(function (item) {
            var selectvalue = {
              value: item.systemId,
              label: item.systemName
            };
            _this.searchFormData[0].selectData.push(selectvalue);
          });
        }
      });
    },
    getHelpDoc: function getHelpDoc() {
      var _this2 = this;
      this.$API.postRequest({
        url: '/platform/helpDoc/list',
        data: this.searchObj
      }).then(function (res) {
        // if (res.code === '200') {
        _this2.tableData = res.result.records;
        _this2.total = res.result.total;
        // }
      });
    },
    searchForm: function searchForm(obj) {
      this.searchObj.fileName = obj[1].value;
      this.searchObj.systemId = obj[0].selectedArr;
      this.searchObj.pageNum = 1;
      this.getHelpDoc();
    },
    currentChange: function currentChange(page) {
      this.searchObj.pageNum = page;
      this.getHelpDoc();
    },
    sizeChange: function sizeChange(size) {
      this.searchObj.pageSize = size;
      this.getHelpDoc();
    },
    getChangeSelect: function getChangeSelect(item) {
      this.searchFormData.selectedArr = item.selectedArr;
    },
    ToBreak: function ToBreak(val) {
      if (val) {
        return valsubstr32addbr(val);
      }
    },
    resetForm: function resetForm() {
      this.searchFormData[0].selectedArr = [];
      this.searchFormData[1].value = '';
      this.searchObj.fileName = '';
      this.searchObj.systemId = '';
      this.searchObj.pageNum = 1;
      this.getHelpDoc();
    },
    downloadfile: function downloadfile(scope) {
      this.$API.getRequest({
        // eslint-disable-next-line no-useless-concat
        url: '/platform/helpDoc/download?' + "id=".concat(scope.row.id, "&download=1"),
        responseType: 'blob'
      }).then(function (res) {
        saveFile(res.data, scope.row.docName);
      });
    },
    gotoDetail: function gotoDetail(scope) {
      this.$router.push({
        path: '/system/helpDoc/helpPdf',
        query: {
          helpDocId: scope.row.id,
          nomal: '111'
        }
      });
    }
  }
};